<template>

    <section class="posts-by-user">
        <div class="panel" v-if="posts && posts.length > 0">
     <!--        <breadcrumbs 
            :breadcrumbs="[{title: 'Forum', link: '/forum'},{title: 'Posts by ' + posts[0].poster.firstName + ' ' + posts[0].poster.lastName, link: '#'}]">
            </breadcrumbs> -->

            <div class="panel-heading"><h2>{{posts[0].poster.firstName}} {{posts[0].poster.lastName}}</h2></div>
            <div class="panel-body">
                <div class="well clearfix">
                    <div class="col-xs-12 col-md-6">
                        <img :src="posts[0].poster.avatar">
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <h3>{{posts[0].poster.firstName}} {{posts[0].poster.lastName}}</h3>
                        <h4 v-if="posts[0].poster.title">{{posts[0].poster.title}}</h4>
<!--                         <router-link :to="{ name: 'inbox', query: { tab: 'compose', to: posts[0].poster.id } }">
                            <button class="btn btn-primary send-message"><i class="fa fa-envelope"></i>Send Message</button>
                        </router-link> -->
                        <ul v-if="posts[0].poster.socialLinks" class="social-links">
                            <li v-for="(value, propertyName) in posts[0].poster.socialLinks">
                                <a :href="value" target="_blank">{{propertyName}}</a>
                               
                                
                            </li>
                        </ul>
                        
                    </div>
                </div>
            </div>
        </div>

        <div class="panel" v-if="posts">
            <div class="panel-heading"><h2>Recent Posts</h2></div>
                <div class="panel-body">
                <ul class="list-group posts">
                    <li class="header forum-header clearfix">
                        <div class="col-xs-1"></div>
                        <div class="col-xs-6">Post</div>
                        <div class="col-xs-3">Thread</div>
                        <div class="col-xs-2">Posted on</div>
                    </li>
                    <li v-for="post in posts" class="clearfix">
                        <router-link  :to="{ name: 'thread', params: { forumId: post.forumId, topicId: post.topicId, postId: post.id } }">
                
                        <div class="col-xs-6">
                            <div v-html="truncate(post.body)"></div>
                        </div>
                        <div class="col-xs-3">
                            {{post.topicTitle}}
                        </div>
                        <div class="col-xs-2">
                            {{post.createdAt | shortDate}}
                        </div>
                    </router-link>
                    </li>
                </ul>

                <ul class="forum-pagination" v-if="totalPages > 1">
                    <li><a class="previous-page" href="#" @click.prevent="setPage(currentPage - 1)">&laquo;</a></li>
                 
                    <li v-for="i in totalPages">
                        <a href="#"  
                        @click.prevent="currentPage = (i - 1)"
                        :class="{'current-page': i === (currentPage+1)}">
                            {{i}}
                        </a>
                    </li>

                    <li><a class="previous-page" href="#" @click.prevent="setPage(currentPage + 1)">&raquo;</a></li>

                </ul>
            </div>

        </div>
    </section>

</template>


<script>

import discussions from '../services/discussions';
import breadcrumbs from './widgets/ForumBreadcrumbs.vue';

export default {
    data() {
        return {
            userId: null,
            posts: null,
            currentPage: 0,
            totalPages: null,

        }
    },
    components: {
        breadcrumbs
    },
    mounted() {
        this.userId = this.$route.query.userId;
        this.getPosts();
    },
    methods: {
        setPage(page) {
            if (page < 0 || page >= this.totalPages) return;
            this.currentPage = page;
        },
        truncate(text) {
            var truncated = text.substr(0, 240);
            if (text.length > 240) truncated += '&hellip;';
            return truncated;
        },
        getPosts() {
            var self = this;
            self.$store.dispatch('toggle',{type:'loading', boolean: true});

            discussions.getPosts(this, null, this.currentPage, this.userId).then(function(response) {
                console.log(response.data.posts.length);
                if (response.data.posts.length > 0 && response.data.posts[0].poster.socialLinks) {
                    response.data.posts[0].poster.socialLinks = JSON.parse(response.data.posts[0].poster.socialLinks.replace(/\\/g,'').substr(1).slice(0, -1));
                }
                self.posts = response.data.posts;
                self.totalPages  = Math.ceil(response.data.count / 10);
                self.$store.dispatch('toggle',{type:'loading', boolean: false});

            });
        }
    },
    watch: {
        currentPage(page) {
            if ( (page < 0) || (page >= this.totalPages)) {
                return;
            } else {
                this.getPosts();
            }
        }
    }
}
</script>


<style lang="scss" scoped>
.send-message {
    i {
        margin-right:1rem;
    }
}
.posts {
    li {
        padding:1rem 0;
        background: #2c2c2c;
        margin: 0 auto 2rem auto;
        width:95%;
        a {
            color:inherit;
        }
    }
    li.header {
        //background:#363636;
    }
}

.forum-header {
    background: #666!important;
    display: block;
    height: 40px;
    padding-top: 11px;  
    width: 97%;
    margin: 0 auto 20px auto;
}


</style>


// WEBPACK FOOTER //
// PostsByUser.vue?66ae96d0